import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-global-modal',
  templateUrl: './global-modal.component.html',
  styleUrls: ['./global-modal.component.scss'], // Pasamos a SCSS para usar variables
  encapsulation: ViewEncapsulation.None // Permite que los estilos modifiquen el mat-dialog-container
})
export class GlobalModalComponent {
  constructor(
    public dialogRef: MatDialogRef<GlobalModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string; type: string }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}